import React from "react"

import { SelectOption } from "shared/types/Select"

import { TeamRole } from "entities/team-members/types/TeamRole"

import { AdminTeamLeaveOverlay } from "./AdminTeamLeaveOverlay"
import { DefaultTeamLeaveOverlay } from "./DefaultTeamLeaveOverlay"
import { AdminTeamLeaveFormData } from "./model/useTeamLeaveOverlayModel"

export interface TeamLeaveOverlayProps {
  role: TeamRole | null | undefined
  isLastAdmin: boolean
  isLastTeamMember: boolean
  isUpdatingAdmin: boolean
  wasLastAdmin: boolean
  hasPendingInvites: boolean
  teamMemberOptions: SelectOption<string>[]
  onUpdateAdmin: (data: AdminTeamLeaveFormData) => void
  onLeaveTeam: () => void
  onCancel: () => void
}

export const TeamLeaveOverlay = React.memo(
  ({
    role,
    isLastAdmin,
    isLastTeamMember,
    isUpdatingAdmin,
    wasLastAdmin,
    hasPendingInvites,
    teamMemberOptions,
    onUpdateAdmin,
    onLeaveTeam,
    onCancel
  }: TeamLeaveOverlayProps) => {
    if (isLastAdmin && !isLastTeamMember && !isUpdatingAdmin) {
      return (
        <AdminTeamLeaveOverlay
          teamMemberOptions={teamMemberOptions}
          hasPendingInvites={hasPendingInvites}
          wasLastAdmin={false}
          onSubmit={onUpdateAdmin}
          onCancel={onCancel}
        />
      )
    }

    return (
      <DefaultTeamLeaveOverlay
        role={role}
        isLastAdmin={isLastAdmin}
        isLastTeamMember={isLastTeamMember}
        isUpdatingAdmin={isUpdatingAdmin}
        wasLastAdmin={wasLastAdmin}
        onSubmit={onLeaveTeam}
        onCancel={onCancel}
      />
    )
  }
)
